import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export type BenefitDesignMaxAllowances = {
  familyStatusId: number
  maxAmount: number
}

export const getBenefitDesignMaxAllowances = (planPeriodId: string): Promise<BenefitDesignMaxAllowances[]> => {
  return adminHttpClient.get(`/AdminDashboard/qsehra/BenefitDesign/MaxAllowances/${planPeriodId}`)
}
